module.exports = __webpack_public_path__ + "img/yuangongtongxinlu.3f29e94c.png";